export class agentDataService {
    constructor(params) {
        this.SingletonWebSocket = params.SingletonWebSocket;
        this.SingletonSharedData = params.SingletonSharedData;
        this.StateRule = params.StateRule;
    }
    GetAgentID() {
        const action = "GetAgentID"
        if (this.StateRule.validate(this.SingletonSharedData.getCurrentStatus(), action)) {
            const message = {
                client: "integration",
                action
            }
            this.SingletonWebSocket.send(message);
        }
    }
    GetUserName() {
        const action = "GetUserName";
        if (this.StateRule.validate(this.SingletonSharedData.getCurrentStatus(), action)) {
            const message = {
                client: "integration",
                action
            }
            this.SingletonWebSocket.send(message);
        }
    }
    GetExtension() {
        const action = "GetExtension"
        if (this.StateRule.validate(this.SingletonSharedData.getCurrentStatus(), action)) {
            const message = {
                client: "integration",
                action
            }
            this.SingletonWebSocket.send(message);
        }
    }
}


// WEBPACK FOOTER //
// ./src/Services/agentDataService.js